import { combineReducers } from 'redux'

import table from './table'

export default combineReducers({
  table,
})
